'use client'

import { HTMLAttributes } from 'react'
import { PDF_EXTRACT_LOCKED_HINT } from '@/app/constants/loanPdfExtract'

interface Props {
    rootProps: HTMLAttributes<HTMLDivElement>
    isDragActive: boolean
    disabled: boolean
    onChoose: () => void
}

export default function LoanPdfExtractDropzone({ rootProps, isDragActive, disabled, onChoose }: Props) {
    return (
        <div
            {...rootProps}
            data-test="pdf-extract-dropzone"
            className={`rounded-2xl border border-dashed p-5 text-center transition-colors md:p-8 ${
                isDragActive ? 'border-rm-blue bg-rm-blue-light/30' : 'border-rm-blue-light bg-rm-blue-accent-bg'
            }`}
        >
            <span className="mx-auto flex size-12 items-center justify-center rounded-full border border-rm-blue-light bg-white text-lg text-rm-blue-accent">
                <i className="fa-regular fa-cloud-arrow-up" />
            </span>

            <p className="m-0 mt-3 font-recoleta text-[17px] font-bold text-pale md:text-[19px]">
                Glissez votre offre de prêt ici
            </p>
            <p className="m-0 mt-1 text-[14px] text-pale/70">
                PDF uniquement · 15 Mo maximum · offre de prêt ou tableau d&apos;amortissement
            </p>

            <button
                type="button"
                onClick={onChoose}
                disabled={disabled}
                data-test="pdf-extract-choose"
                className={`mt-4 w-full rounded-xl px-6 py-3 text-[15px] font-bold text-white transition-colors md:w-auto ${
                    disabled ? 'cursor-not-allowed bg-rm-blue-light' : 'bg-rm-blue hover:bg-rm-blue-deep'
                }`}
            >
                Choisir un fichier
            </button>

            {disabled && (
                <p
                    data-test="pdf-extract-locked"
                    className="mx-auto mt-3 flex w-fit items-center gap-2 rounded-lg border border-yellow-700 bg-yellow-100 px-3 py-2 text-[13px] text-yellow-900"
                >
                    <i className="fa-regular fa-lock" />
                    {PDF_EXTRACT_LOCKED_HINT}
                </p>
            )}
        </div>
    )
}
